import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { ScheduledTransaction } from 'app-components/flux/scheduled-transactions/scheduledTransactionsTypes';
import type { TransactionProps, TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'VIEW_SERIES_DIALOG';

export const showViewSeriesDialog = createAction(
  rootUiActions.createDialog.toString(),
  (txn: TransactionRecord | TransactionProps | (ScheduledTransaction & { stModelId?: string })) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        txn,
      }),
    }),
);
